import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const TitleContainer = styled.div`
  position: relative;
  display: flex;

  > svg {
    position: absolute;
    top: -6px;
    left: -32px;
    opacity: 0.2;
    width: 60px;
    height: 60px;
    color: ${themeGet('colors.primary.main')};
  }

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    > svg {
      top: 0;
    }
  }
`
